/* eslint-disabled */

export default class QuestionConditionGroupExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
